module.exports = __webpack_public_path__ + "static/37-c205f30c841e3698edfe550dc402b83f.png";